import { render, staticRenderFns } from "./dashboard_ksa.vue?vue&type=template&id=96640a02&scoped=true&"
import script from "./dashboard_ksa.vue?vue&type=script&lang=js&"
export * from "./dashboard_ksa.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_ksa.vue?vue&type=style&index=0&id=96640a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96640a02",
  null
  
)

export default component.exports